import React, { useState, useEffect, useRef } from 'react';
import {
  Modal,
  Form,
  Select,
  Tooltip,
  Spin,
  Button,
  notification,
  Popconfirm,
} from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import hielocosService from '../../services/hielocos';
import debounce from '../../helpers/debounce';
import {
  PlusIcon,
  SearchIcon,
  StarIcon,
  TrashIcon,
  XIcon,
} from '@heroicons/react/outline';
import { Ghost } from 'react-kawaii';
import Hieloco from '../hielocos/hieloco';
import cardsService from '../../services/cards';
import Errors from '../errors';
import {
  deleteCardHieloco as deleteCardHielocoAction,
  addCardHieloco as addCardHielocoAction,
} from '../../store/actions/cards';
import { fetchHielocos as fetchHielocosAction } from '../../store/actions/hielocos';

const { Option } = Select;

const MAX_CARD_HIELOCOS = 5;

const CardHielocos = ({ card }) => {
  const { items } = useSelector((state) => state.hielocos);

  const dispatch = useDispatch();

  const [modal, showModal] = useState(false);
  const [search, setSearch] = useState();
  const [addHieloco, setAddHieloco] = useState(false);
  const [cardHielocos, setCardHielocos] = useState([]);
  const [filteredHielocos, setFilteredHielocos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [loadingAdd, setLoadingAdd] = useState(false);

  const [hieloco, setHieloco] = useState();

  const addFormRef = useRef();

  useEffect(() => {
    if (modal) {
      fetchCardHielocos();

      dispatch(fetchHielocosAction());
    }
    //eslint-disable-next-line
  }, [modal]);

  const fetchCardHielocos = async () => {
    try {
      setLoading(true);
      const { items } = await cardsService.getCardHielocos(card.id);

      setCardHielocos(items);

      setTimeout(() => {
        setLoading(false);
      }, 500);
    } catch (error) {
      setLoading(false);
      notification.open({
        type: 'error',
        message: 'Ocurrio un error al obtener los hielocos de la tarjeta',
        placement: 'bottomRight',
      });
    }
  };

  useEffect(() => {
    searchHieloco(search);
    //eslint-disable-next-line
  }, [search, items]);

  async function searchHieloco(search) {
    if (!search) return setFilteredHielocos(items);

    const beginSearch = async () => {
      try {
        setLoadingSearch(true);
        let filtered = [];
        filtered = items.filter((hieloco) => {
          const name = hieloco.name.toLowerCase();

          return name.indexOf(search.toLocaleLowerCase()) > -1;
        });

        if (filtered.length === 0) {
          const { items } = await hielocosService.search(search);

          filtered = items;
        }

        setLoadingSearch(false);
        return filtered;
      } catch (error) {
        setLoadingSearch(false);
      }
    };

    const filteredHielocos = await debounce(beginSearch);

    setFilteredHielocos(filteredHielocos);
  }

  async function addCardHieloco() {
    try {
      setLoadingAdd(true);
      const selectedHieloco = JSON.parse(hieloco);

      const response = await cardsService.addCardHieloco(
        card.id,
        selectedHieloco.id
      );

      const cardHieloco = {
        card_id: card.id,
        hieloco_id: selectedHieloco.id,
        Hieloco: selectedHieloco,
      };

      setCardHielocos([...cardHielocos, cardHieloco]);

      setHieloco(null);

      setAddHieloco(false);

      dispatch(addCardHielocoAction(card.id, cardHieloco));

      notification.open({
        type: 'success',
        message: response.message,
        placement: 'bottomRight',
      });

      setLoadingAdd(false);
    } catch (error) {
      console.log(error);
      setLoadingAdd(false);
      notification.open({
        type: 'error',
        message: 'No se pudo agregar el hieloco',
        description: <Errors errors={error?.errors} />,
        placement: 'bottomRight',
      });
    }
  }

  async function deleteCardHieloco(hieloco) {
    try {
      const response = await cardsService.delelteCardHieloco(
        hieloco.card_id,
        hieloco.hieloco_id
      );

      const index = cardHielocos.findIndex(
        (item) =>
          item.card_id === hieloco.card_id &&
          item.hieloco_id === hieloco.hieloco_id
      );

      cardHielocos.splice(index, 1);

      setCardHielocos([...cardHielocos]);

      dispatch(deleteCardHielocoAction(card.id, hieloco.hieloco_id));

      notification.open({
        type: 'success',
        message: response.message,
        placement: 'bottomRight',
      });
    } catch (error) {
      console.log(error);
      notification.open({
        type: 'error',
        message: 'No se pudo eliminar el hieloco',
        description: <Errors errors={error?.errors} />,
        placement: 'bottomRight',
      });
    }
  }

  const hielocoOptions = filteredHielocos.map((hieloco) => (
    <Option key={hieloco.id} value={JSON.stringify(hieloco)}>
      <div className="flex gap-2 items-center">
        <img alt="hielocoImage" src={hieloco.image_url} className="h-8" />
        <span className="w-full truncate">{hieloco.name}</span>
      </div>
    </Option>
  ));

  return (
    <>
      <div className="flex gap-1" onClick={() => showModal(true)}>
        <StarIcon width={16} /> Poaps
      </div>

      <Modal
        visible={modal}
        title={null}
        footer={null}
        closable={false}
        width={800}
      >
        <div className="space-y-3">
          <div className="flex justify-between">
            <h2 className="text-xl font-medium">
              Hielocos tarjeta {card.code}
            </h2>
            <button onClick={() => showModal(false)}>
              <XIcon width={23} />
            </button>
          </div>
          {!addHieloco ? (
            <>
              <Button
                disabled={cardHielocos.length === MAX_CARD_HIELOCOS}
                className="flex items-center gap-1 cursor-pointer"
                onClick={() => setAddHieloco(true)}
              >
                <PlusIcon width={20} />
                <span>Agregar</span>
              </Button>
            </>
          ) : (
            <div>
              <h2 className="text-base mb-2">Agregar hieloco</h2>

              <Form layout="horizontal" ref={addFormRef}>
                <Form.Item>
                  <Select
                    placeholder="Buscar Hieloco"
                    showSearch
                    value={hieloco}
                    showArrow={false}
                    onChange={(value) => setHieloco(value)}
                    onSearch={(search) => setSearch(search)}
                    filterOption={false}
                    notFoundContent={
                      search &&
                      !loadingSearch && <div>No se encontrarón Hielocos.</div>
                    }
                    size="large"
                    className="rounded-sm"
                  >
                    {hielocoOptions}
                  </Select>
                  <div className="absolute right-2 top-3 flex gap-2">
                    {loadingSearch && <Spin size="small" />}
                    <Tooltip title="Cancelar">
                      <XIcon
                        onClick={() => setAddHieloco(false)}
                        width={18}
                        className="text-black text-opacity-50 cursor-pointer"
                      />
                    </Tooltip>
                    <SearchIcon
                      width={18}
                      className="text-black text-opacity-50"
                    />
                  </div>
                </Form.Item>
              </Form>
              <div className="-mt-3">
                <Button
                  onClick={() => addCardHieloco()}
                  className="bg-green-500 text-white hover:bg-green-600 hover:text-white focus:bg-green-700 focus:text-white"
                  disabled={!hieloco || loadingAdd}
                >
                  Agregar {loadingAdd && <Spin size="small" />}
                </Button>
              </div>
            </div>
          )}
        </div>

        {loading ? (
          <div className="flex justify-center items-center h-40">
            Cargando... <Spin />
          </div>
        ) : (
          <div className="mt-4">
            {cardHielocos.length === 0 ? (
              <div className="w-full flex flex-col justify-center items-center">
                <Ghost size={100} mood="sad" color="#d7d8d8a7" />
                <p className="text-xl mt-2">No has agregado ningún hieloco</p>
              </div>
            ) : (
              <>
                <h2 className="text-lg font-medium">
                  Hielocos agregados {cardHielocos.length}/{MAX_CARD_HIELOCOS}
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-2">
                  {cardHielocos.map((hieloco) => (
                    <Hieloco
                      hieloco={hieloco.Hieloco}
                      key={`${hieloco.card_id}-${hieloco.hieloco_id}`}
                      menu={
                        <Popconfirm
                          title={
                            <div>
                              <span>
                                Esta seguro que desea eliminar el hieloco de la
                                tarjeta?
                              </span>
                              <div className="text-xs text-black text-opacity-50">
                                Solo se eliminará de la tarjeta.
                              </div>
                            </div>
                          }
                          onConfirm={() => deleteCardHieloco(hieloco)}
                          okText="Eliminar"
                          cancelText="Cancelar"
                          placement="top"
                        >
                          <TrashIcon width={18} />
                        </Popconfirm>
                      }
                    />
                  ))}
                </div>
              </>
            )}
          </div>
        )}
      </Modal>
    </>
  );
};

export default CardHielocos;
